import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/of';
import { environment } from '../environments/environment';
import { Http, Response, Headers, RequestOptions, ResponseContentType } from '@angular/http';


@Injectable()
export class VersionService {
  constructor(private _http: Http) {}

  getBackendVersion(): Observable<any> {
    return this._http.get(environment.apiEndpoint+'/health/info')
      .map((res: Response) => res.json())
      .catch(() => Observable.of(null));
  }
}



// WEBPACK FOOTER //
// ./src/app/version.service.ts